import { createContext, useContext } from 'react';
import type { Tast } from '../innboks/Tastaturkart.tsx';

/**
 * Tastaturkartet har ÉN tilstand, og den bor i skallet (DD-11 presisert 2026-09-20, P4).
 *
 * Til R4.3 bodde den i sidens `Kartknapp`: knappen eide `useState`, `?`-bindingen og
 * dialogen. Det gikk så lenge kartet bare hadde én inngang. Konseptet gir det to —
 * sidens ikon over 900 px og raden i «⋯» under — og to innganger til samme dialog kan
 * ikke eie hver sin tilstand. Skallet eier den; sidene melder bare inn HVA kartet skal
 * vise, fordi tastene er sidens egne (innboksens `j`/`k` virker ikke på Innstillinger).
 */
export interface Kart {
  /** Sidens navn og taster. Meldes inn når sidens `Kartknapp` monteres, og ryddes når den forsvinner. */
  meldInn: (tittel: string, taster: Tast[]) => void;
  rydd: () => void;
  aapne: () => void;
}

const Kontekst = createContext<Kart | null>(null);

export const KartProvider = Kontekst.Provider;

export function useKart(): Kart {
  const k = useContext(Kontekst);
  if (!k) throw new Error('[innspel] <Kartknapp> må stå inne i skallet (KartProvider).');
  return k;
}
